import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const AreaPropTypes = PropTypes.shape({
    _id: PropTypes.string,
    areaName: PropTypes.string,
    zoneId: PropTypes.string,
    areaType: PropTypes.string,
    stateId: PropTypes.number,
    cityId: PropTypes.string,
    pincode: PropTypes.string,
    lat: PropTypes.number,
    lng: PropTypes.number,
});

export const AreaDefaultProps = {
    areaName: '',
    zoneId: '',
    areaType: '',
    stateId: '',
    cityId: '',
    pincode: '',
};

export const AreaYupSchema = Yup.object().shape({
    zoneId: Yup.string().required('Required'),
    stateId: Yup.string().required('Required'),
    cityId: Yup.string().required('Required'),
    areaName: Yup.string().min(2, 'Too Short!').max(70, 'Too Long!').required('Required'),
    pincode: Yup.string().min(6, 'It should 6 digits!').max(6, 'It should 6 digits!'),
});

export default {
    AreaDefaultProps,
    AreaPropTypes,
    AreaYupSchema,
};
